module.exports = __webpack_public_path__ + "static/media/hiking.423e6ffb.jpeg";